import { render } from "./_ModalBody.vue?vue&type=template&id=5ab8a878&scoped=true"
import script from "./_ModalBody.vue?vue&type=script&lang=js"
export * from "./_ModalBody.vue?vue&type=script&lang=js"

import "./_ModalBody.vue?vue&type=style&index=0&id=5ab8a878&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab8a878"],['__file',"src/scripts/sections/modals/_ModalBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ab8a878"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ab8a878', __exports__)) {
    api.reload('5ab8a878', __exports__)
  }
  
  module.hot.accept("./_ModalBody.vue?vue&type=template&id=5ab8a878&scoped=true", () => {
    api.rerender('5ab8a878', render)
  })

}


export default __exports__